import VueRouter from "vue-router";

import splashAccepted from "../src/middleware/splashAccepted";
import membershipCheck from "../src/middleware/membershipCheck";
import advertisingStore from "../src/middleware/advertisingStore";
import streamingServer from "../src/middleware/streamingServer";

import Home from "./views/Home2021";
import PageNotFound from "./views/PageNotFound";
import AboutDivas from "./views/AboutDivas";
import VideoWatch from "./views/VideoWatch";
import VideoIndex from "./views/VideoIndex";
import VideoHotspot from "./views/VideoHotspot";
import CategoryIndex from "./views/CategoryIndex";
import Feeds from "./views/Feeds";
import OutstandingsIndex from "./views/OutstandingsIndex";
import WebstarsIndex from "./views/WebstarsIndex";
import WebstarsSearch from "./views/WebstarsSearch";
import FrequentlyAskedQuestions from "./views/FrequentlyAskedQuestions.vue";
import Dashboard from "./views/Dashboard";
import LoginRegister from "./views/LoginRegister";
import Splash from "./views/Splash";
import RecoverPassword from "./views/RecoverPassword";
import ConfirmEmail from "./views/ConfirmEmail";
import SignedOut from "./views/SignedOut";
import FinishRegistration from "./views/FinishRegistration";
import Casting from "./views/Casting";

// SignUp Views
import SignUp from "./views/SignUp/index.vue";
import SignUpUser from "./views/SignUp/User.vue";
import SignUpGeneral from "./views/SignUp/General.vue";

import Maintenance from "./views/Maintenance";
import Support from "./views/Support";
import Tokens from "./views/Tokens";
import Payments from "./views/Payments";
import SubscriptionsHistory from "./views/SubscriptionsHistory";
import ChangeUsername from "./views/ChangeUsername";
import ChangePassword from "./views/ChangePassword";
import NotificationsSettings from "./views/NotificationsSettings";
import CookiesPolicy from "./views/CookiesPolicy";
import Logout from "./views/Logout";
import LoginWithToken from "./views/LoginWithToken";
import Room from "./views/Chat/Room.vue";

// Model Views
import Model from "./views/Model";
import ModelProfile from "./views/Model/ModelProfile";
import ModelPost from "./views/Model/Post";

// Payment Views
import Payment from "./views/Payment";
import PaymentResult from "./views/Payment/Result";
import PaymentResultCcbill from "./views/Payment/ResultCcbill";

// Report Views
import Report from "./views/Report/index.vue";
import ReportModel from "./views/Report/Model.vue";

// Purchase Views
import Purchase from "./views/Purchase";
import PurchaseTokens from "./views/Purchase/Tokens";
import PurchaseSubscription from "./views/Purchase/Subscription";
import PayLink from "./views/Purchase/PayLink";
import DeprecatedPurchaseTokens from "./views/Purchase/deprecated/BuyTokens";
import DeprecatedPurchaseSubscription from "./views/Purchase/deprecated/Subscribe";

// VideoChat Views
import VideoChat from "./views/VideoChat";
import VideoChatEnd from "./views/VideoChatEnd";

// Single Views
import Claims from "./views/Claims";

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    { name: "splash", path: "/", component: Splash, meta: { splash: false } },
    {
      name: "home",
      path: "/home",
      component: Home,
      props: { selectedTab: "celebrities" },
    },

    {
      name: "celebrities",
      path: "/celebrities",
      component: Home,
      props: { selectedTab: "celebrities" },
    },

    {
      name: "outstandings",
      path: "/outstandings",
      component: Home,
      props: { selectedTab: "outstanding" },
    },
    // { name: 'outstandings',           path: '/outstandings',               component: OutstandingsIndex },

    {
      name: "feeds.index",
      path: "/feeds/",
      component: Home,
      props: { selectedTab: "feeds" },
    },
    // { name: 'feeds.index',    path: '/feeds/',             component: Feeds },

    { name: "room", path: "/room", component: Room, meta: { auth: true } },
    //{ name: '404',       path: '/404',                   component: PageNotFound },
    {
      name: "dashboard",
      path: "/dashboard",
      component: Dashboard,
      meta: { auth: true },
    },

    {
      path: "/payment/:paymentId",
      component: Payment,
      children: [
        //Tiene un redirect especial este componente en mounted
        { name: "payment.result", path: "result", component: PaymentResult },

        //Tiene un redirect especial este componente en mounted
        {
          name: "payment.result.ccbill",
          path: "result_ccbill",
          component: PaymentResultCcbill,
        },
      ],
    },

    {
      path: "/signup",
      component: SignUp,
      meta: { auth: false },
      children: [
        { name: "signup", path: "/", component: SignUpGeneral },
        { name: "signup.user", path: "user", component: SignUpUser },
      ],
    },

    {
      name: "login",
      path: "/login",
      component: LoginRegister,
      meta: { auth: false },
    },
    {
      name: "token_login",
      path: "/token_login/:token/:model_id",
      component: LoginWithToken,
    },
    {
      name: "logout",
      path: "/logout",
      component: Logout,
      meta: { auth: true },
    },

    {
      name: "claims",
      path: "/claims",
      component: Claims,
      meta: { auth: true },
    },
    {
      path: "/purchase",
      component: Purchase,
      redirect: { name: "home" },
      meta: { membership: false },
      children: [
        { name: "purchase.tokens", path: "tokens", component: PurchaseTokens },
        {
          name: "purchase.subscription",
          path: "subscription",
          component: PurchaseSubscription,
        },
      ],
    },

    {
      path: "/subscribe",
      component: DeprecatedPurchaseSubscription,
      membership: false,
    },

    { name: "video.search", path: "/videos/search", component: VideoIndex },
    { name: "video.index", path: "/videos", component: VideoIndex },
    { name: "video.hotspot", path: "/videos/hot", component: VideoHotspot },
    { name: "video.watch", path: "/videos/:id/watch", component: VideoWatch },

    { name: "category.index", path: "/categories", component: CategoryIndex },

    {
      name: "model.profile",
      path: "/models/:id/profile",
      component: ModelProfile,
    },

    {
      name: "webstars.index",
      path: "/webstars/",
      component: Home,
      props: { selectedTab: "webstars" },
    },
    // { name: 'webstars.index', path: '/webstars/',          component: WebstarsIndex },
    {
      name: "webstars.search",
      path: "/webstar/search",
      component: WebstarsSearch,
    },

    { name: "about", path: "/about/", component: AboutDivas },

    { name: "faqs", path: "/faqs/", component: FrequentlyAskedQuestions },

    {
      name: "user.recover",
      path: "/recover/",
      component: RecoverPassword,
      meta: { auth: null },
    },
    {
      name: "user.finish",
      path: "/finish/",
      component: FinishRegistration,
      meta: { auth: false },
    },
    {
      name: "user.confirm",
      path: "/verify/",
      component: ConfirmEmail,
      meta: { auth: null },
    },

    { name: "signedout", path: "/signedout/", component: SignedOut },

    {
      name: "casting",
      path: "/casting/",
      component: Casting,
      meta: { auth: false },
    },

    {
      name: "support",
      path: "/support",
      component: Support,
      meta: { auth: null },
    },
    {
      name: "maintenance",
      path: "/maintenance",
      component: Maintenance,
      meta: { auth: null },
    },
    {
      name: "buytokens",
      path: "/buytokens",
      component: DeprecatedPurchaseTokens,
      meta: { membership: false },
    },

    {
      name: "tokens",
      path: "/tokens",
      component: Tokens,
      meta: { auth: true },
    },
    {
      name: "payments",
      path: "/payments",
      component: Payments,
      meta: { auth: true },
    },
    {
      name: "subscriptions",
      path: "/subscriptions",
      component: SubscriptionsHistory,
      meta: { auth: true, active: true },
    },
    {
      name: "subscriptions_history",
      path: "/subscriptions_history",
      component: SubscriptionsHistory,
      meta: { auth: true },
    },
    {
      name: "subscription.payments",
      path: "/subscription/:subscription/payments",
      component: Payments,
      meta: { auth: true },
    },
    {
      name: "change_username",
      path: "/change_username",
      component: ChangeUsername,
      meta: { auth: true },
    },
    {
      name: "change_password",
      path: "/change_password",
      component: ChangePassword,
      meta: { auth: true },
    },
    {
      name: "notifications",
      path: "/notifications",
      component: NotificationsSettings,
      meta: { auth: true },
    },

    { name: "cookies.policy", path: "/cookies", component: CookiesPolicy },
    {
      name: "cookies.availability",
      path: "/cookies-availability",
      component: PageNotFound,
    },

    { name: "videocall-end", path: "/videocall-end", component: VideoChatEnd },
    {
      name: "videocall",
      path: "/videocall/:hash",
      component: VideoChat,
      meta: { auth: true },
    },

    // warning: al ser un parámetro en root, dejar esto abajo para no romper las otras rutas
    {
      path: "/:username",
      component: Model,
      children: [
        { name: "model.username", path: "/", component: ModelProfile },
        { name: "model.post", path: "post/:post", component: ModelPost },
        {
          path: "paylink",
          component: Purchase,
          redirect: { name: "/:username" },
          meta: { membership: false },
          children: [
            { name: "model.paylink", path: ":hash", component: PayLink },
          ],
        },
      ],
    },

    {
      path: "/report",
      component: Report,
      children: [
        { name: "report.model", path: "model/:modelId", component: Claims },
        //{ name: 'report.model', path: 'model/:modelId', component: ReportModel },
      ],
    },

    { name: "error404", path: "/:pathMatch(.*)*", component: PageNotFound },
  ],
});

router.beforeEach((to, from, next) => {
  // Actualiza la ruta anterior en el objeto 'meta' de la ruta actual
  to.meta.previousRoute = from;
  next();
});

/* Splash middleware con redirect para stats */
router.beforeEach(advertisingStore);
router.beforeEach(splashAccepted);
/* Splash middleware con redirect para stats */
router.beforeEach(streamingServer);

/* Membership middleware */
router.afterEach(membershipCheck);
/* Membership middleware */

export default router;
